import { render, staticRenderFns } from "./ExchangeContractTotals.vue?vue&type=template&id=447f18e2&scoped=true&"
import script from "./ExchangeContractTotals.vue?vue&type=script&lang=js&"
export * from "./ExchangeContractTotals.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeContractTotals.vue?vue&type=style&index=0&id=447f18e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447f18e2",
  null
  
)

export default component.exports